/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Run_Resuming_BodyInputs */



/**
* | output |
* | --- |
* | "The run was approved and will continue on its own." |
*
* @param {Agent_Run_Resuming_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_run_resuming_body = /** @type {((inputs?: Agent_Run_Resuming_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Run_Resuming_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Lauf wurde freigegeben und wird von selbst fortgesetzt.")
	return /** @type {LocalizedString} */ ("The run was approved and will continue on its own.")
});